$(function () {
    onChangeUpsellColor();
    // initSlider();
    onloadHideOOSSize();
    initTabsCollFlickity();
    // onloadVideoBackground();
});

initSlider = () => {
    $('.jsc-upsell-slider').flickity({
        cellAlign: 'left',
        freeScroll: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        contain: true
    });
}

onChangeUpsellColor = () => {
    $(".jsc-upsell-swatch").change(function() {
        var selectedSize = $(this).parents('form').find('.jsc-selected-size').val();
        var selectedColor = $(this).val();
        var allVariantObj = JSON.parse($(this).parents('form').find('variant-info-hidden').text());
        var selectedVariantId = returnVariantID(selectedSize, selectedColor, allVariantObj);
        var isVariantAvailable = returnVariantAvailability(selectedSize, selectedColor, allVariantObj);
        
        $(this).parents('form').find('.jsc-vid-hidden').val(selectedVariantId);

        $(this).parents('.radio__buttons').find('.jsc-upsell-swatch').prop('checked', false);
        $(this).prop('checked', true);

        upsellAvailabilityButton(this, isVariantAvailable);
    });
}

onClickUpsellSize = (e) => {
    var selectedSize = $(e).attr('data-value');
    var selectedColor = $(e).parents('form').find(".jsc-upsell-swatch:checked").val();
    var allVariantObj =  JSON.parse($(e).parents('form').find('variant-info-hidden').text());
    var selectedVariantId = returnVariantID(selectedSize, selectedColor, allVariantObj);
    var isVariantAvailable = returnVariantAvailability(selectedSize, selectedColor, allVariantObj);
    
    $(e).parents('form').find('.jsc-vid-hidden').val(selectedVariantId);

    upsellAvailabilityButton(e, isVariantAvailable);

    
}

upsellAvailabilityButton = (evt, isVariantAvailable) => {
    setTimeout(() => {
        if (isVariantAvailable) {
            $(evt).parents('form').find('.jsc-upsell-btn').prop('disabled', false).find('.btn__text').text('Add to Cart');
        } else {
            $(evt).parents('form').find('.jsc-upsell-btn').prop('disabled', true).find('.btn__text').text('Sold Out');
        }
    }, 300);
}

returnVariantID = (option1, option2, obj) => {
    var vIdNum = 0;
    for (const iterator of obj) {
        var variantOption1 = iterator.option1;
        var variantOption2 = iterator.option2;
        
        if ((variantOption1 == option1 && variantOption2 == option2) || (variantOption1 == option2 && variantOption2 == option1)) {
            vIdNum = iterator.id;
        }
    }

    return vIdNum;
}

returnVariantAvailability = (option1, option2, obj) => {
    var isVariantAvailable = false;
    for (const iterator of obj) {
        var variantOption1 = iterator.option1;
        var variantOption2 = iterator.option2;
        
        if ((variantOption1 == option1 && variantOption2 == option2) || (variantOption1 == option2 && variantOption2 == option1)) {
            console.log('oooo', iterator);
            isVariantAvailable = iterator.available;
        }
    }

    return isVariantAvailable;
}

triggerATC = (e) => {
    var _this = $(e);

    _this.siblings('.jsc-upsell-btn-hidden').click();
}

removeGiftBox = () => {
    setTimeout(() => {
        $('.jsc-gift-box-remove')[0].click();
    }, 2100);
}

//Mix n Match scripts starts here
onloadHideOOSSize = () =>{
    var selectedColor = $('mix-and-match-card').find('input[type="radio"]:checked');
    
    selectedColor.each(function(){
        var _this = $(this);
        disableOOSSizeOptionMixMatch(_this.val(), this);
    });
}

disableOOSColorOptionMixMatch = (selectedSize, e) =>{
    var _this = $(e);
    var card = _this.parents('mix-and-match-card');
    var hiddenVariantOption = card.find('.jsc-hidden-variants option');
    var colorRadioInputElements = card.find('radio-swatch input');

    colorRadioInputElements.removeClass('sold-out');

    hiddenVariantOption.each(function(){
        var __this = $(this);
        var isInStoke = __this.attr('data-inventory') == 'true';
        var variantTitle = __this.val();
        if (!isInStoke && variantTitle.includes(selectedSize)) {
            var colorSwatchToDisable = variantTitle.replace(selectedSize, '').replace(' / ', '');
            colorRadioInputElements.filter(`[value="${colorSwatchToDisable}"]`).addClass('sold-out');
        }
    });

}
mixNMatchSizeSelect = (e) => {
    var _this = $(e);
    var sizeVal = _this.val();
    var colorVal = _this.parents('mix-and-match-card').find('input[type="radio"]:checked').val();

    var combinedOptionName = `${sizeVal} / ${colorVal}`;

    _this.parents('mix-and-match-card').find('.jsc-hidden-variants').val(combinedOptionName);

    // update with newly selected variant id
    updateMixNMatchID(_this);
    disableOOSColorOptionMixMatch(sizeVal,e)

}
disableOOSSizeOptionMixMatch = (selectedColor,e) =>{
    var _this = $(e);
    var card = _this.parents('mix-and-match-card');
    var hiddenVariantOption = card.find('.jsc-hidden-variants option');
    var sizeOptionElements = card.find('size-select select option');

    sizeOptionElements.prop('disabled', false);

    hiddenVariantOption.each(function(){
        var __this = $(this);
        var isInStoke = __this.attr('data-inventory') == 'true';
        var variantTitle = __this.val();
        if (!isInStoke && variantTitle.includes(selectedColor)) {
            var sizeOptionToDisable = variantTitle.replace(selectedColor, '').replace(' / ', '');
            sizeOptionElements.filter(`[value="${sizeOptionToDisable}"]`).prop('disabled', true);
        }
    });
}
mixNMatchColorSelect = (e) => {
    var _this = $(e);
    var colorVal = _this.val();
    var sizeVal = _this.parents('mix-and-match-card').find('size-select select').val();

    var combinedOptionName = `${sizeVal} / ${colorVal}`;

    _this.parents('mix-and-match-card').find('.jsc-hidden-variants').val(combinedOptionName);

    // update with newly selected variant id
    updateMixNMatchID(_this);

    disableOOSSizeOptionMixMatch(colorVal, e);
}

updateMixNMatchID = (_this) => {
    var selectedVariant = _this.parents('mix-and-match-card').find('.jsc-hidden-variants option:selected');
    var variantId = selectedVariant.text();
    var productForm = _this.parents('mix-and-match-card').find('form');

    var allInventoryStatus = _this.parents('mix-and-match').find('.jsc-hidden-variants option:selected').map(function () {
        var isInventory = true;
        $(this).each(function () {
            if ($(this).attr('data-inventory') === 'false') {
                isInventory = false;
            }
        });
        return isInventory;
    }).get();
    
    var hasFalseVaraint = allInventoryStatus.includes(false);

    if (hasFalseVaraint) {
        _this.parents('mix-and-match').find('.jsc-mix-n-match-atc-btn').prop('disabled', true).find('.btn__text').text('Sold Out');
    } else {
        _this.parents('mix-and-match').find('.jsc-mix-n-match-atc-btn').prop('disabled', false).find('.btn__text').text('Add to Cart');
    }
    
    productForm.find('input[name="id"]').val(variantId);
}

mixNMatchTriggerATC = (e) => {
    var _this = $(e);
    var productForm = _this.parents('mix-and-match').find('form');

    const buttons = productForm.find('button');
    clickButtonsSequentially(0, buttons);
}

async function clickButtonsSequentially(index, buttons) {
    if (index < buttons.length) {
        await new Promise((resolve) => setTimeout(resolve, 900));
        buttons.eq(index).click();
        clickButtonsSequentially(index + 1, buttons);
    }
}
//Mix n Match scripts ends here


//start: reinitiate tab collection slider
initTabsCollFlickity = () => {
    var $tabs_coll_slider = $('.jsc-tabs-coll-flickity');
  
    setTimeout(function(){
      if ($(window).width() > 799) {
        $tabs_coll_slider.each(function(){
        //   console.log($(this));
          // $(this).flickity('destroy');
          $(this).flickity({
            // options
            cellAlign: 'left',
            pageDots: false,
            wrapAround: false,
            groupCells: 3,
            prevNextButtons: true,
            setGallerySize: true,
            // adaptiveHeight: true,
            // watchCSS: true,
            on: {
                ready: function() {
                $(this.element).addClass('jsc-flickity-initiated');
                }
            }
          });
          $(this).flickity('resize');
        //   $(this).find('.grid-item').css("height","105%");
        });
      }
    },1500);
  
    // setTimeout(function(){},1500);
}
//end: reinitiate tab collection slider

//start: video section background
onclickVideoBackground = (e) => {
    // $('.jsc-video-style').parents('.pswp__zoom-wrap').css('background','#000');
    // setTimeout(function(){
    //     var $this_pswp = $('.jsc-video-style').parents('.pswp__zoom-wrap');
    //     $this_pswp.addClass('jsc-video-parent');
    //     // console.log('the video1',$this_pswp);
    // },100);
    
}
//end: video section background